import { getOgmaSupportedLanguagesUri } from './utils/getOgmaUris';
import getOgmaSupportedLanguageTag from '../utils/getOgmaSupportedLanguageTag';
import setOgmaHeaders from './utils/setOgmaHeaders';
import SupportedLanguage from '../store/schema/SupportedLanguage';

export default async function getSupportedLanguages(
    clientLocale: string
): Promise<Map<string, SupportedLanguage>> {
    const promise = new Promise<Map<string, SupportedLanguage>>(function(resolve, reject) {
        const xhttp = new XMLHttpRequest();

        xhttp.onload = function() {
            if (xhttp.status === 200) {
                const languageMap = parseGetSupportedLanguagesResult(this.responseText);
                if (languageMap) {
                    resolve(languageMap);
                } else {
                    reject('OGMA returned invalid response: ' + this.response);
                }
            } else {
                reject('OGMA failed to retrieve supported languages: ' + this.response);
            }
        };

        xhttp.onerror = function() {
            reject('OGMA call failed: ' + this.response);
        };

        const ogmaSupportedLanguageTag = getOgmaSupportedLanguageTag(clientLocale);
        xhttp.open('GET', getOgmaSupportedLanguagesUri(ogmaSupportedLanguageTag));
        setOgmaHeaders(xhttp);
        xhttp.send();
    });

    return promise;
}

function parseGetSupportedLanguagesResult(
    supportedLanguages: string
): Map<string, SupportedLanguage> {
    try {
        const languageMap = new Map<string, SupportedLanguage>();
        JSON.parse(supportedLanguages).forEach(function(supportedLanguage) {
            languageMap.set(supportedLanguage.LanguageTag, supportedLanguage);
        });
        return languageMap;
    } catch (error) {
        return null;
    }
}
